// @core/api/endpoints/booking/create_resource.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  BookableResourceResponse,
  CreateResourceRequest,
} from '../../../types/booking';

const BASE_PATH = '/booking';

/**
 * Create bookable resource
 * Creates a new bookable resource (trainer, apartment, vehicle, salon chair, etc.).
 */
export async function CreateResource(
  data: CreateResourceRequest,
  options?: RequestOptions
): Promise<BookableResourceResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/resources`;
  const requestOptions = options;
  return client.post<BookableResourceResponse>(requestPath, data, requestOptions);
}
